(() => {
  if (window.shyCommerceUXLoaded) return;
  window.shyCommerceUXLoaded = true;
  const syncConfirmation = (product, unavailable) => {
    const confirmation = product.querySelector('[data-made-order-confirm]');
    const button = product.querySelector('.product-form__submit');
    if (!confirmation || !button) return;
    if (typeof unavailable === 'boolean') product.dataset.shyVariantUnavailable = String(unavailable);
    if (!('shyVariantUnavailable' in product.dataset)) {
      let variant = null;
      try { variant = JSON.parse(product.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch (_) { /* Keep unavailable until a valid variant is known. */ }
      const tracked = variant?.inventory_management === 'shopify' && variant?.inventory_policy !== 'continue';
      const quantityUnavailable = tracked && Number(variant?.quantity_rule?.min || 1) > Number(variant?.inventory_quantity || 0);
      product.dataset.shyVariantUnavailable = String(!variant || !variant.available || quantityUnavailable);
    }
    const blocked = product.dataset.shyVariantUnavailable === 'true' || !confirmation.checked || Boolean(product.pendingRequestUrl);
    confirmation.required = true;
    button.disabled = blocked;
    button.classList.toggle('shy-button-disabled', !confirmation.checked);
  };
  const setup = (root = document) => {
    const products = new Set(root.querySelectorAll('product-info'));
    if (root.matches?.('product-info')) products.add(root);
    const parentProduct = root.closest?.('product-info');
    if (parentProduct) products.add(parentProduct);
    products.forEach((product) => {
      syncConfirmation(product);
      product.querySelectorAll('.shy-made-order').forEach((notice) => {
        if (notice.dataset.uxReady) return;
        notice.dataset.uxReady = 'true';
        const text = notice.querySelector('.shy-made-order__text');
        const list = notice.querySelector('.shy-made-order__list');
        if (!text || !list) return;
        const details = document.createElement('details');
        details.className = 'shy-production-details';
        const summary = document.createElement('summary');
        summary.textContent = product.dataset.productionDetailsLabel || 'Production and delivery details';
        details.append(summary);
        text.before(details);
        details.append(text, list);
      });
    });
    root.querySelectorAll('.shy-medical-cap-nav-wrap').forEach((wrapper) => {
      if (wrapper.dataset.uxReady) return;
      const nav = wrapper.querySelector('.shy-medical-cap-nav');
      const controls = wrapper.querySelector('.shy-medical-cap-nav__controls');
      if (!nav || !controls) return;
      wrapper.dataset.uxReady = 'true';
      const buttons = controls.querySelectorAll('button');
      const update = () => {
        controls.hidden = nav.scrollWidth <= nav.clientWidth + 2;
        buttons[0].disabled = nav.scrollLeft <= 2;
        buttons[1].disabled = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
      };
      buttons.forEach((button) => button.addEventListener('click', () => {
        nav.scrollBy({ left: (button.dataset.capScroll === 'next' ? 1 : -1) * nav.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }));
      nav.addEventListener('focusin', (event) => {
        const link = event.target.closest('a');
        if (!link || !nav.contains(link)) return;
        const bounds = nav.getBoundingClientRect();
        const target = link.getBoundingClientRect();
        const inset = 6;
        let delta = 0;
        if (target.left < bounds.left + inset) delta = target.left - bounds.left - inset;
        else if (target.right > bounds.right - inset) delta = target.right - bounds.right + inset;
        if (delta) nav.scrollTo({ left: nav.scrollLeft + delta, behavior: 'auto' });
        update();
      });
      nav.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(nav);
      update();
    });
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-made-order-confirm]')) {
      const product = event.target.closest('product-info');
      if (product) syncConfirmation(product);
      return;
    }
    const picker = event.target.closest('variant-selects');
    if (!picker) return;
    const product = picker.closest('product-info');
    if (!product) return;
    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      const checked = fieldset.querySelector('input:checked');
      const selected = fieldset.querySelector('[data-selected-value]');
      if (checked && selected) selected.textContent = checked.value;
    });
    product.querySelectorAll('.shy-product-facts>div').forEach((row) => {
      const key = row.querySelector('dt').textContent.trim();
      const fieldset = [...picker.querySelectorAll('fieldset')].find((item) => item.querySelector('legend')?.textContent.trim().startsWith(key + ':'));
      const select = [...picker.querySelectorAll('select')].find((item) => item.name === `options[${key}]`);
      const checked = fieldset?.querySelector('input:checked');
      if (checked || select) row.querySelector('dd').textContent = (checked || select).value;
    });
  });
  const bindVariantUpdates = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const product = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      if (!product || !data.html) return;
      const sourceSubmit = data.html.getElementById(`ProductSubmitButton-${data.sectionId}`);
      syncConfirmation(product, !data.variant?.available || !sourceSubmit || sourceSubmit.disabled);
      ['ShyProductFacts', 'ShyDispatch'].forEach((prefix) => {
        const id = `${prefix}-${data.sectionId}`;
        const source = data.html.getElementById(id);
        const destination = product.querySelector(`[id="${id}"]`);
        if (source && destination) destination.innerHTML = source.innerHTML;
      });
    });
  };
  document.addEventListener('submit', (event) => {
    const product = event.target.closest('product-info');
    const confirmation = product?.querySelector('[data-made-order-confirm]');
    if (!confirmation || confirmation.checked || !event.target.matches('form[data-type="add-to-cart-form"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    confirmation.required = true;
    confirmation.focus();
    confirmation.reportValidity();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindVariantUpdates); else bindVariantUpdates();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => { if (node.nodeType === 1 && node.querySelectorAll) setup(node); }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
